var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4876 23.4604C18.3821 23.4604 17.4379 22.5527 17.6578 21.4693C17.7297 21.1148 17.8243 20.7995 17.9415 20.5235C18.2451 19.8 18.7373 19.1743 19.4181 18.6465C20.0989 18.1187 20.6141 17.6378 20.9637 17.2036C21.3226 16.761 21.502 16.2758 21.502 15.748C21.502 14.4626 20.9039 13.8199 19.7079 13.8199C19.1559 13.8199 18.7097 14.0072 18.3693 14.3817C17.7523 15.0606 17.1011 15.9012 16.1838 15.9012H15.545C14.2356 15.9012 13.0972 14.7804 13.635 13.5865C13.9245 12.9439 14.3479 12.3918 14.9054 11.9301C16.0462 10.9767 17.647 10.5 19.7079 10.5C21.7596 10.5 23.3466 10.9384 24.4691 11.8152C25.6007 12.692 26.1665 13.9391 26.1665 15.5565C26.1665 16.263 26.0147 16.9057 25.7111 17.4845C25.4075 18.0634 24.9199 18.655 24.2482 19.2594L22.6612 20.6257C22.2104 21.0258 21.8976 21.4386 21.7228 21.8642C21.3717 22.7019 20.7101 23.4604 19.8018 23.4604H19.4876ZM16.9202 27.3421C16.9202 26.7121 17.164 26.1971 17.6516 25.797C18.1485 25.3884 18.7649 25.1841 19.5009 25.1841C20.2369 25.1841 20.8487 25.3884 21.3364 25.797C21.8332 26.1971 22.0816 26.7121 22.0816 27.3421C22.0816 27.972 21.8332 28.4913 21.3364 28.8999C20.8487 29.3 20.2369 29.5 19.5009 29.5C18.7649 29.5 18.1485 29.3 17.6516 28.8999C17.164 28.4913 16.9202 27.972 16.9202 27.3421Z",
    fill: "url(#paint0_radial_5230_24420)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5230_24420",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7228 35.048) rotate(-90) scale(29.2386 59.7165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/No.2aaaf7f695dc1bbaed9ee7a21facc028.svg";
export { ForwardRef as ReactComponent };